import styled from 'styled-components';

export const StyledDeleteAgent = styled.div`
  width: 100%;
  font-size: 18px;
  line-height: 22px;
  color: var(--light-gray);

  .holder {
    padding: 20px 0;
  }

  .title {
    display: block;
    font-size: 20px;
    line-height: 24px;
    font-weight: 700;
    margin: 0 0 15px;
    color: var(--text-color);
  }

  .btn-holder {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding-top: 30px;
  }
`;
